import ReactDOM from "react-dom/client";
import "src/utils/initialization";
import "./assetRetryServiceWorker";
// TODO: importing routes from router, with routes.tsx nextdoor is confusing and unnecessary, and is left as an exercise to the reader to sort out.
import { routes } from "./router";
import { RouterProvider, createHashRouter } from "react-router-dom";
import { getHashRouterPathRedirectUrl } from "src/utils/hashRouterPathRedirect";
import { activateLocale } from "@web-monorepo/i18n";
import { logException } from "@classdojo/log-client";

const pathRedirectUrl = getHashRouterPathRedirectUrl({ location: window.location, pathPrefixes: ["/referrals"] });

if (pathRedirectUrl) {
  window.location.replace(pathRedirectUrl);
} else {
  // Opt into React Router v7 behavior (RR 6.30 warns until you do). These data-router flags are
  // behavioral no-ops here — the app routes by element + React Query (no page currently exports a
  // loader/action, no useFetcher/<Form>, no splat relative nav, no fallbackElement) — so they only
  // silence the warnings. v7_startTransition is intentionally left off: it defers URL updates and
  // breaks URL-driven state (see the teach pilot); the RR v7/v8 upgrade will use useTransitions={false}.
  // Matches teach/app/index.tsx.
  const router = createHashRouter(routes, {
    future: {
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_relativeSplatPath: true,
      v7_skipActionErrorRevalidation: true,
    },
  });

  const root = document.getElementById("root");
  if (!root) throw new Error("couldn't find #root element");
  const app = <RouterProvider router={router} />;

  // Activate before the first paint, so translated text paints translated rather than flashing
  // English. `finally`, not `then`: a catalog that fails to load must still render the app. Its
  // Lingui strings show as message ids until a route's own load retries the catalog, which is
  // degraded but usable, and better than a blank page.
  //
  // The rejection is logged here rather than left to a global handler: Sentry is initialised in
  // `_app.tsx`, which is downstream of this render, so a failure at this point would happen before
  // anything was listening and vanish silently. `logException` works because
  // `src/utils/initialization` ran at import time.
  void activateLocale()
    .catch((error: unknown) => {
      logException(error instanceof Error ? error : new Error(String(error)), ["i18n", "activateLocale"]);
    })
    .finally(() => ReactDOM.createRoot(root).render(app));
}
